import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BlankComponent } from '@reenstudio/app/shared/layouts/blank/blank.component';
import { FullComponent } from '@reenstudio/app/shared/layouts/full/full.component';
import { AppErrorComponent } from '@reenstudio/app/shared/layouts/error/error.component';

import { AuthGuard } from './core/guard/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('@reenstudio/app/pages/login/login.module').then(
        (m) => m.LoginModule,
      ),
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'history',
        loadChildren: () =>
          import('./pages/monitoring/monitoring.module').then(
            (m) => m.MonitoringModule,
          ),
      },
      {
        path: 'forecast',
        loadChildren: () =>
          import('./pages/forecast/forecast.module').then(
            (m) => m.ForecastModule,
          ),
      },
      {
        path: 'meter-readings',
        loadChildren: () =>
          import('./pages/meter-readings/meter-readings.module').then(
            (m) => m.MeterReadingsModule,
          ),
      },
      {
        path: 'incentive',
        loadChildren: () =>
          import('./pages/incentive/incentive.module').then(
            (m) => m.IncentiveModule,
          ),
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('./pages/administration/administration.module').then(
            (m) => m.AdministrationModule,
          ),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/login/login.module').then((m) => m.LoginModule),
      },
    ],
  },
  {
    path: 'error',
    component: AppErrorComponent,
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
